'use client';
import React from 'react';

export const Policy = () => {
  return (
    <div>
      <h2 className="mb-3 text-left">
        <b>Privacy Policy</b>
      </h2>
      <p className="mb-5 text-left">
        <b>Last Modified:</b> October 8, 2024
      </p>
      <h3 className="text-left text-lg font-bold">1. Introduction</h3>

      <p className="mb-5 text-left">
        Tytum (&ldquo;we,&ldquo; &ldquo;us,&ldquo; or &ldquo;our&ldquo;)
        respects your privacy and is committed to protecting it through this
        Privacy Policy. This policy explains how we collect, use, disclose, and
        protect your personal information when you visit our website{' '}
        <a href="https://tytum.com">(&ldquo;Website&ldquo;)</a> , and your
        rights under California law.
      </p>
      <h3 className="text-left text-lg font-bold">2. Information We Collect</h3>
      <p className="mb-5 text-left">
        We may collect the following categories of personal information from
        you:
      </p>
      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          <b>Identifiers:</b> Name, email address, postal address, phone number,
          IP address.
        </li>
        <li className="text-left">
          <b>Commercial Information:</b> Records of products or services
          purchased or considered.
        </li>
        <li className="text-left">
          <b>Internet Activity:</b> Browsing history, search history, and
          interactions with our Website.
        </li>
        <li className="text-left">
          <b>Geolocation Data: </b> Location information based on your IP
          address.
        </li>
        <li className="text-left">
          <b>Professional or Employment Information: </b> Current or past
          employment details.
        </li>
      </ul>

      <h3 className="text-left text-lg font-bold">
        3. How We Use Your Information
      </h3>
      <p className="mb-5 text-left">
        We may use your information for the following purposes:
      </p>
      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          To provide, support, personalize, and develop our Website.
        </li>
        <li className="text-left">
          To communicate with you, including responding to your inquiries and
          sending marketing materials.
        </li>
        <li className="text-left">To analyze and improve our services.</li>
        <li className="text-left">To ensure security and prevent fraud.</li>
      </ul>

      <h3 className="text-left text-lg font-bold">
        4. Sharing Your Information
      </h3>
      <p className="mb-5 text-left">
        We do not sell your personal information. We may share your information
        with:
      </p>
      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          <b>Service Providers:</b> Third-party vendors who assist with our
          business operations.
        </li>

        <li className="text-left">
          <b>Legal Obligations:</b> As required by law or to protect our rights.
        </li>
      </ul>

      <h3 className="text-left text-lg font-bold">
        5. Your Rights Under California Law
      </h3>
      <p className="mb-5 text-left">
        If you are a California resident, you have the following rights:
      </p>
      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          <b>Right to Know: </b> You have the right to request details about the
          personal information we collect, use, disclose, and sell.
        </li>

        <li className="text-left">
          <b>Right to Delete:</b> You can request that we delete your personal
          information, subject to certain exceptions.
        </li>

        <li className="text-left">
          <b>Right to Opt-Out:</b> You can opt-out of the sale of your personal
          information.
        </li>

        <li className="text-left">
          <b>Right to Non-Discrimination:</b> We will not discriminate against
          you for exercising any of your CCPA rights.
        </li>
      </ul>

      <p className="mb-5 text-left">
        To exercise these rights, please contact us at: contact@tytum.com or
        619-349-4397.{' '}
      </p>

      <h3 className="text-left text-lg font-bold">
        6. Cookies and Tracking Technologies{' '}
      </h3>
      <p className="mb-5 text-left">
        We use cookies and similar tracking technologies to enhance your
        experience on our Website.{' '}
      </p>

      <h3 className="text-left text-lg font-bold">Types of Cookies We Use:</h3>

      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          <b>Essential Cookies: </b> Necessary for the basic functionality of
          the site.
        </li>

        <li className="text-left">
          <b>Performance Cookies: </b> Help us understand how visitors interact
          with the site.
        </li>

        <li className="text-left">
          <b>Functional Cookies:</b> Remember your preferences and settings.
        </li>

        <li className="text-left">
          <b>Targeting Cookies: </b> Deliver relevant advertisements and track
          the effectiveness of our marketing campaigns.
        </li>
      </ul>
      <h3 className="text-left text-lg font-bold">Managing Cookies</h3>

      <p className="mb-5 text-left">
        You can control and manage cookies through your browser settings. Please
        note that disabling certain cookies may impact your experience on our
        Website.
      </p>

      <h3 className="text-left text-lg font-bold">7. Updates to This Policy</h3>

      <p className="mb-5 text-left">
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated effective date.
      </p>

      <h3 className="text-left text-lg font-bold">8. Contact Us</h3>

      <p className="mb-5 text-left">
        If you have any questions about this Privacy Policy, please contact us
        at:
      </p>
      <p className="mb-5 text-left">Email: contact@tytum.com </p>
      <p className="mb-5 text-left">Phone: 619-349-4397</p>
      <p className="mb-10 text-left">
        Address: 16950 Via De Santa Fe, Suite 5060-136, Rancho Santa Fe, CA
        92091
      </p>

      <h3 className="text-left text-lg font-bold">Cookie Policy</h3>

      <h3 className="text-left text-lg font-bold">1. Introduction</h3>

      <p className="mb-5 text-left">
        Our Website uses cookies to improve your experience, provide social
        media features, and analyze our traffic. This Cookie Policy explains
        what cookies are, how we use them, and how you can manage your cookie
        preferences.
      </p>

      <h3 className="text-left text-lg font-bold">2. What Are Cookies?</h3>

      <p className="mb-5 text-left">
        Cookies are small text files stored on your device when you visit a
        website. They help the site recognize your device and store certain
        information about your preferences.
      </p>

      <h3 className="text-left text-lg font-bold">Types of Cookies We Use:</h3>

      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          <b>Strictly Necessary Cookies: </b>Required for the Website to
          function correctly.
        </li>

        <li className="text-left">
          <b>Performance Cookies: </b> Collect information on how you use the
          Website, such as which pages you visit.
        </li>

        <li className="text-left">
          <b>Functional Cookies:</b> Allow the Website to remember your choices,
          such as language preferences.
        </li>

        <li className="text-left">
          <b>Targeting Cookies: </b> Track your browsing habits to show you
          relevant advertisements.
        </li>
      </ul>

      <h3 className="text-left text-lg font-bold">4. How We Use Cookies</h3>

      <p className="mb-5 text-left">We use cookies to:</p>

      <ul className="mb-5 list-disc pl-10">
        <li className="text-left">
          Keep you logged in and remember your preferences.
        </li>

        <li className="text-left">
          Analyze website traffic and user behavior.
        </li>

        <li className="text-left">
          Provide personalized content and advertisements.
        </li>
      </ul>

      <h3 className="text-left text-lg font-bold">5. Managing Cookies</h3>

      <p className="mb-5 text-left">
        You can control and delete cookies through your browser settings. Most
        browsers allow you to refuse or accept cookies, delete cookies, or be
        notified before a cookie is stored.
      </p>

      <h3 className="text-left text-lg font-bold">
        6. Changes to This Cookie Policy
      </h3>

      <p className="mb-5 text-left">
        We may update this Cookie Policy from time to time. Any changes will be
        reflected on this page with an updated effective date.
      </p>

      <h3 className="text-left text-lg font-bold">7. Contact Us</h3>

      <p className="mb-5 text-left">
        If you have any questions about this Cookie Policy, please contact us
        at:
      </p>
      <p className="mb-5 text-left">Email: contact@tytum.co</p>
      <p className="mb-5 text-left">mPhone: 619-349-4397</p>
      <p className="mb-5 text-left">
        Address: 16950 Via De Santa Fe, Suite 5060-136, Rancho Santa Fe, CA
        92091
      </p>
    </div>
  );
};
